/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   deepclone.js (https://stackoverflow.com/a/5344074)
 */

import { deepclone } from '@zcode/nr-utils'

/** @deprecated import { deepclone } from '@zcode/nr-utils' instead */
export default deepclone
